import React, { useEffect, useRef, useState } from 'react';
import { StyledBannerConfig } from './StyledBannerConfig';
import {gsap} from 'gsap';

const BannerConfig = ({ }) => {

  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 1023)

  const overlay = useRef()
  const videoEl = useRef()

  const toggleOpenOverlay  = (open) => {
    
    gsap.to(overlay.current,{x: open ? 0 : '-100%', ease: "power2.easeInOut", duration: .75,
    onComplete: () => {
      if(!isDesktop){
        if(open) videoEl.current.play()
        else videoEl.current.pause()
      }
    }})
    
  }

  const resize = () => {
    setIsDesktop(window.innerWidth > 1023)
  }

  useEffect(() => {
    window.addEventListener('resize', resize)
    return () => {
      window.removeEventListener('resize', resize)
    }
  },[])

  return (
    <React.Fragment>
      {
       
          <StyledBannerConfig
          >
            <div className="banner-tech--content">
              <div className="banner-tech--content-col col--img">
                <img src={require('../../assets/banner-config.png')} />
              </div>
              <div className="banner-tech--content-col col--text">
                <h5 className="big--title">
                  Want to see how your customers can customize your products?
                </h5>
                <div className="cta--primary cursor-cta" onClick={() => toggleOpenOverlay(true)}>
                  <p className="preset-10 cursor-cta" >Check out the configurator</p>
                  
                  <svg width="14" className="next cursor-cta" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path className="cursor-cta" d="M7.66675 10.6673L13.0001 6.00065L7.66675 1.33398" stroke="#45B865" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                    <path className="cursor-cta" d="M13 6H1" stroke="#45B865" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              </div>
            </div>

            <div className="overlay--zoom" ref={overlay}>
              <div className="close--overlay" onClick={() => toggleOpenOverlay()}>
                <img src={require('../../assets/close-overlay-black.png')} />
              </div>
              {
                isDesktop ?
                <iframe src="https://invrsion-sketchfab-configurator.s3.eu-central-1.amazonaws.com/release/sketchfabconfigurator_v1.0.4.html" />
                : 
                <video ref={videoEl} muted controls>
                  <source src={require('../../assets/configurator.mp4')} type="video/mp4"></source>
                </video>

              }
            </div>

            
          </StyledBannerConfig>
          
      }
    </React.Fragment>
  );
};

BannerConfig.propTypes = {};

BannerConfig.defaultProps = {
  tag: "div",
  bgColor: "#fff"
};

export default BannerConfig;
